import { useEffect, useRef } from "react";

/** Arguments for {@link useInfiniteScroll}. */

/** Loads the next page when a returned sentinel element nears the scroll bottom. */
export function useInfiniteScroll(_ref) {
  var rootRef = _ref.rootRef,
    hasMore = _ref.hasMore,
    isLoading = _ref.isLoading,
    onLoadMore = _ref.onLoadMore;
  var sentinelRef = useRef(null);
  useEffect(function () {
    var sentinel = sentinelRef.current;
    var root = rootRef.current;
    if (!sentinel || !root || !hasMore) return undefined;
    var observer = new IntersectionObserver(function (entries) {
      var _entries$;
      var isScrollable = root.scrollHeight > root.clientHeight + 1;
      if ((_entries$ = entries[0]) !== null && _entries$ !== void 0 && _entries$.isIntersecting && isScrollable && hasMore && !isLoading) onLoadMore();
    }, {
      root: root,
      rootMargin: "120px"
    });
    observer.observe(sentinel);
    return function () {
      return observer.disconnect();
    };
  }, [rootRef, hasMore, isLoading, onLoadMore]);
  return sentinelRef;
}